import { Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { Store } from '@services/setting-services/models';
import { TokenService } from '@services/auth-services/token.service';
import { TenantStore } from '@services/tenant-services/models';
import { StoreApiService } from '@services/setting-services/store-api.service';
import { ApiService } from '@services/core-services/api.service';
import { TenantWithAuthApiService } from '@services/tenant-services/tenant-api.service';

@Injectable({ providedIn: 'root' })
export class StoresService {
  constructor(
    private readonly api: ApiService,
    private readonly storeApiService: StoreApiService,
    private readonly tenantWithAuthApiService: TenantWithAuthApiService,
    private readonly tokenService: TokenService
  ) {}

  list(): Observable<Store[]> {
    return of([]);
  }

  getConfig(): Observable<Store[]> {
    return this.api.get<any>('store/config').pipe(
      map((response: any) => {
        return response.content.store_config;
      })
    );
  }

  getStores(tenantId: string) {
    return this.tenantWithAuthApiService.get<any>(`tenants/${tenantId}/stores`).pipe(
      map((response: any) => {
        return response.content.stores as Store[];
      })
    );
  }

  getStore(tenantId: string, storeId: string) {
    const currentStoreId = storeId || this.tokenService.getCurrentStoreId();
    return this.api.get<any>(`tenants/${tenantId}/stores/${currentStoreId}`).pipe(
      map((response: any) => {
        return response.content.store as Store;
      })
    );
  }

  createStore(tenantId: string, payload: any) {
    return this.storeApiService
      .post<any, any>(`tenants/${tenantId}/stores`, payload)
      .pipe(map(response => response.content.store as TenantStore));
  }

  updateStore(tenantId: string, storeId: string, payload: any) {
    return this.storeApiService
      .put<any, any>(`tenants/${tenantId}/stores/${storeId}`, payload)
      .pipe(map(response => response.content.store as TenantStore));
  }

  switchStore(storeId: string) {
    return this.api.post<any, any>('tenants/witch-store', { store_id: storeId });
  }

  deleteStore(tenantId: string, storeId: string) {
    return this.tenantWithAuthApiService.delete<any>(`tenants/${tenantId}/stores/${storeId}`);
  }
}
